// @flow
import * as React from 'react';
import { IconTheme } from './theme';

type SizeOption = 'sm' | 'md' | 'lg' | 'xl';

type IconProps = {
  /**
   * The color of the icon, should be pulled from the `PrimaryPalette`
   */
  color?: string,
  /**
   * The size of the icon. This value will be ignored if the text is within typography
   */
  size?: SizeOption,
};

type IconSvgWrapperProps = {
  children: React.Node,
  size: SizeOption,
};

const defaultIconProps = {
  color: IconTheme.default.color,
  size: 'md',
};

const SIZE_MAP = {
  sm: '16',
  md: '24',
  lg: '48',
  xl: '64',
};

export const IconSvgWrapper = (props: IconSvgWrapperProps) => {
  const { children, size } = props;

  return (
    <svg
      className="seedling-birch-icon"
      fill="none"
      height={SIZE_MAP[size]}
      width={SIZE_MAP[size]}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </svg>
  );
};

// This Icon is only used for Storybook to be able to autogenerate the ArgTypes based on the component
export const EmptyIcon = (_: IconProps) => <React.Fragment />;

export { defaultIconProps };
export type { IconProps };
